
import React from 'react';
import moment from 'moment';

class DateTime extends React.Component {

    static propTypes = {
        showSec: React.PropTypes.bool,
        value: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.number
        ]),
    };

    render() {
        const {value, showSec} = this.props;
        if (value === null) return <span />;

        const format = !!showSec ? 'D.M.YYYY H:mm:ss' : 'D.M.YYYY H:mm';
        return (
            <span>
                {moment(value).format(format)}
            </span>
        );
    }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/browser/components/numbers/DateTime.js